import {execSync} from 'node:child_process';

import compareVersions from 'compare-versions';

export interface DoctorResult {
  ok: boolean;
  message: string;
}

export const checkNodeVersion = (): DoctorResult => {
  try {
    const version: string = process.version.replace(/^v/, ''); // 'v24.6.0' -> '24.6.0'
    const ok: boolean = compareVersions.compare(version, '22.0.0', '>=');

    return {
      message: ok
        ? `Node version is ${version} ✅`
        : `Node version is ${version}, but >= 22.0.0 is required ❌`,
      ok
    };
  } catch (error: unknown) {
    const msg = error instanceof Error ? error.message : 'Failed to check Node version ❌';

    return {message: msg, ok: false};
  }
};

/**
 * Check Flutter version >= 3.2.0
 */
export const checkFlutterVersion = (): DoctorResult => {
  try {
    const stdout: string = execSync('flutter --version', {encoding: 'utf-8'});
    const match: RegExpMatchArray | null = stdout.match(/Flutter (\d+\.\d+\.\d+)/);

    if (!match || !match[1]) {
      return {message: 'Cannot parse Flutter version ❌', ok: false};
    }

    const version: string = match[1];
    const ok: boolean = compareVersions.compare(version, '3.2.0', '>=');

    return {
      message: ok
        ? `Flutter version is ${version} ✅`
        : `Flutter version is ${version}, but >= 3.2.0 is required ❌`,
      ok
    };
  } catch (error: unknown) {
    const msg =
      error instanceof Error ? error.message : 'Flutter is not installed or not in PATH ❌';

    return {message: msg, ok: false};
  }
};

/**
 * Check Dart version >= 3.8.0
 */
export const checkDartVersion = (): DoctorResult => {
  try {
    const stdout: string = execSync('dart --version', {encoding: 'utf-8', stdio: 'pipe'});
    const match: RegExpMatchArray | null = stdout.match(/Dart SDK version: (\d+\.\d+\.\d+)/);

    if (!match || !match[1]) {
      return {message: 'Cannot parse Dart version ❌', ok: false};
    }

    const version: string = match[1];
    const ok: boolean = compareVersions.compare(version, '3.8.0', '>=');

    return {
      message: ok
        ? `Dart version is ${version} ✅`
        : `Dart version is ${version}, but >= 3.8.0 is required ❌`,
      ok
    };
  } catch (error: unknown) {
    const msg = error instanceof Error ? error.message : 'Dart is not installed or not in PATH ❌';

    return {message: msg, ok: false};
  }
};

export const runDoctor = (): DoctorResult[] => [
  checkNodeVersion(),
  checkFlutterVersion(),
  checkDartVersion()
];
